import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const FoxLogo = ({ size = 32, className = '' }) => {
  const [isBlinking, setIsBlinking] = useState(false);

  // Rastgele göz kırpma efekti (Canlılık hissi için)
  useEffect(() => {
    const blinkInterval = setInterval(() => {
      if (Math.random() > 0.7) {
        setIsBlinking(true);
        setTimeout(() => setIsBlinking(false), 200);
      }
    }, 3000);
    return () => clearInterval(blinkInterval);
  }, []);

  return (
    <motion.div 
        className={`relative flex items-center justify-center ${className}`}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
    >
      <motion.svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        initial="initial"
        animate="animate"
      >
        <defs>
          {/* Cyberpunk Gradient */}
          <linearGradient id="foxGradient" x1="24" y1="6" x2="24" y2="38" gradientUnits="userSpaceOnUse">
            <stop stopColor="#EA580C" /> {/* Fox Orange */}
            <stop offset="1" stopColor="#C2410C" />
          </linearGradient>
          
          <linearGradient id="earGradient" x1="24" y1="6" x2="24" y2="14" gradientUnits="userSpaceOnUse">
            <stop stopColor="#F97316" />
            <stop offset="1" stopColor="#EA580C" />
          </linearGradient>

          {/* Holographic Glow Filter */}
          <filter id="glow" x="-20%" y="-20%" width="140%" height="140%">
            <feGaussianBlur stdDeviation="2" result="blur" />
            <feComposite in="SourceGraphic" in2="blur" operator="over" />
          </filter>
        </defs>

        {/* Head Shape */}
        <motion.path
          d="M24 6L14 12L12 20C12 20 12 24 14 28C16 32 20 36 24 38C28 36 32 32 34 28C36 24 36 20 36 20L34 12L24 6Z"
          fill="url(#foxGradient)"
          filter="url(#glow)"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
        />
        
        {/* Ears */}
        <path d="M14 12L18 8L20 12L18 14L14 12Z" fill="url(#earGradient)" />
        <path d="M34 12L30 8L28 12L30 14L34 12Z" fill="url(#earGradient)" />
        
        {/* Inner Ear Detail (Tech Lines) */}
        <path d="M16 10L18 9L19 11L17 12L16 10Z" fill="white" opacity="0.4" />
        <path d="M32 10L30 9L29 11L31 12L32 10Z" fill="white" opacity="0.4" />
        
        {/* Eyes Group (Blinking Animation) */}
        <motion.g
            animate={isBlinking ? { scaleY: 0.1 } : { scaleY: 1 }}
            transition={{ duration: 0.1 }}
            style={{ originY: "20px", originX: "24px" }}
        >
            {/* Eye Sclera */}
            <circle cx="18" cy="20" r="3" fill="white" />
            <circle cx="30" cy="20" r="3" fill="white" />
            
            {/* Pupils (Deep Midnight) */}
            <circle cx="18" cy="20" r="1.8" fill="#020617" />
            <circle cx="30" cy="20" r="1.8" fill="#020617" />
            
            {/* Cyber Glint */}
            <circle cx="18.8" cy="19.2" r="0.8" fill="white" opacity="0.9" />
            <circle cx="30.8" cy="19.2" r="0.8" fill="white" opacity="0.9" />
        </motion.g>
        
        {/* Snout Area */}
        <path
          d="M24 26C22 26 19 25 19 23C19 21.5 21 21 24 21C27 21 29 21.5 29 23C29 25 26 26 24 26Z"
          fill="white"
          opacity="0.9"
        />
        
        {/* Nose */}
        <ellipse cx="24" cy="23.2" rx="1.5" ry="2" fill="#020617" />
        
        {/* Smile (Subtle) */}
        <path
          d="M21.5 24.5C22.5 25.2 24 25.2 26.5 24.5"
          stroke="#020617"
          strokeWidth="0.8"
          strokeLinecap="round"
          opacity="0.4"
        />
      </motion.svg>
    </motion.div>
  );
};

export default FoxLogo;